var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.2 11.999V3.777a1.8 1.8 0 0 1 1.8-1.8H6.22a.467.467 0 0 1 0 .933H4a.866.866 0 0 0-.866.867v8.222a.87.87 0 0 0 .866.867h8.222a.87.87 0 0 0 .867-.867V9.777a.467.467 0 1 1 .934 0v2.222a1.8 1.8 0 0 1-1.8 1.8H3.998a1.8 1.8 0 0 1-1.8-1.8m11.728-5.667a.467.467 0 0 1-.934 0V3.58l-6.663 6.747a.467.467 0 0 1-.664-.656l6.677-6.76H9.683a.467.467 0 0 1 0-.934h3.778c.258 0 .467.209.467.466z"
})));
export default SvgArrowSquare;